/* Linsoul support pages. Fork of the prototype support.js + support-home.js + support-search.js.
   Every customer-facing string comes from section settings via [data-sp-config] JSON. */
(function () {
  'use strict';

  var cfg = {};
  document.querySelectorAll('script[data-sp-config]').forEach(function (s) {
    try {
      var o = JSON.parse(s.textContent);
      Object.keys(o).forEach(function (k) { cfg[k] = Object.assign(cfg[k] || {}, o[k]); });
    } catch (e) { console.error('Support config unreadable', e); }
  });

  var params = new URLSearchParams(location.search);
  function q(s, r) { return (r || document).querySelector(s); }
  function qa(s, r) { return Array.from((r || document).querySelectorAll(s)); }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function fill(str, vars) { return String(str || '').replace(/\{(\w+)\}/g, function (m, k) { return vars && vars[k] != null ? vars[k] : m; }); }
  function text(s) { return String(s || '').normalize('NFKD').replace(/[\u0300-\u036f]/g, '').toLowerCase().replace(/[^a-z0-9]+/g, ' ').trim(); }
  function safeURL(s) { try { var u = new URL(s, location.href); return ['https:', 'http:'].indexOf(u.protocol) > -1 ? u.href : '#'; } catch (e) { return '#'; } }
  function caseURL(base, id, topic) {
    var u = new URL(base || '/pages/support-contact', location.origin);
    if (topic) u.searchParams.set('topic', topic);
    if (id) u.searchParams.set('case', id);
    return u.pathname + u.search;
  }
  function copyText(value) {
    if (navigator.clipboard && window.isSecureContext) return navigator.clipboard.writeText(value);
    return new Promise(function (resolve, reject) {
      var e = document.createElement('textarea');
      e.value = value; e.style.position = 'fixed'; e.style.opacity = '0';
      document.body.append(e); e.select();
      var ok = false;
      try { ok = document.execCommand('copy'); } finally { e.remove(); }
      ok ? resolve() : reject(new Error('copy'));
    });
  }

  /* ---------- FAQ ranking (deterministic, prototype support-search.js) ---------- */
  var Search = (function () {
    function normalize(value) {
      return String(value || '').normalize('NFKD').replace(/[\u0300-\u036f]/g, '').toLowerCase()
        .replace(/[\u2018\u2019]/g, "'").replace(/\b(hasn'?t|haven'?t|isn'?t|wasn'?t|didn'?t|doesn'?t)\b/g, 'not')
        .replace(/\bcan'?t\b/g, 'cannot').replace(/\bcancle\b/g, 'cancel').replace(/\bpre[ -]order\b/g, 'preorder').replace(/[^a-z0-9]+/g, ' ').trim();
    }
    var stop = new Set('i my me we our the a an to of for is are be been was have has can could would should do does did how what when where why please it its this that with and or need want get help some still just am yet about on in at as you us'.split(' '));
    function intent(q) {
      if (/\b(cancel|cancellation|cancelled|canceled)\b/.test(q)) {
        if (/\b(preorder|custom|customized)\b/.test(q)) return ['cancel-preorder', 'cancel-order'];
        if (/\b(shipped|dispatched)\b/.test(q) && !/\b(not|before|unshipped)\b/.test(q)) return ['cancel-shipped', 'cancel-order'];
        return ['cancel-order', 'cancel-shipped', 'cancel-preorder'];
      }
      if (/\b(address|postcode|postal|change order|wrong option)\b/.test(q) && !/\b(return|returns|rma)\b/.test(q)) return ['wrong-address', 'cancel-order'];
      if (/\b(credit|store credit)\b/.test(q)) return ['store-credit', 'refund-time'];
      if (/\b(refund|refunds|money back)\b/.test(q)) return ['refund-time', 'store-credit'];
      if (/\b(delivered)\b/.test(q) && /\b(not|cannot|missing|nowhere|find|here|received)\b/.test(q)) return ['delivered-missing', 'order-not-arrived'];
      if (/\b(tracking|track|scan|scans)\b/.test(q) && /\b(stuck|update|updating|moving|changed|stopped|scans)\b/.test(q)) return ['order-no-scan', 'order-not-arrived'];
      if (/\b(no|not|missing|never)\b/.test(q) && /\b(dispatch|shipping|tracking)\b/.test(q) && /\b(email|number|notification)\b/.test(q)) return ['tracking-number', 'order-not-dispatched'];
      if (/\b(preorder|customized|custom)\b/.test(q)) return ['preorder', 'order-not-dispatched'];
      if (/\b(unshipped|not shipped|not dispatched|not sent|has not shipped|has not been shipped)\b/.test(q) || (/\b(not|never)\b/.test(q) && /\b(order|parcel)\b/.test(q) && /\b(shipped|dispatched)\b/.test(q))) return ['order-not-dispatched', 'order-not-arrived'];
      if (/\b(wrong|damaged|broken|missing|incomplete)\b/.test(q) && /\b(item|items|component|accessory|box|contents|product)\b/.test(q)) return ['damage-arrival'];
      if ((/\b(order|parcel|package|shipment|delivery)\b/.test(q) && /\b(arrived|received|missing|late|delayed|lost|not here|where|wheres|stuck)\b/.test(q)) || q === 'not arrived' || q === 'not received') return ['order-not-arrived', 'order-no-scan', 'tracking-number'];
      if (/\b(no sound|not working|quieter|quiet|left|right|one side|earbud|earpiece)\b/.test(q)) return /\b(usb|dac|computer)\b/.test(q) ? ['usb-no-sound', 'one-side-quiet'] : ['one-side-quiet', 'usb-no-sound'];
      if (/\b(unboxing|wrong item|missing item)\b/.test(q)) return ['damage-arrival'];
      if (/\b(manual|driver|firmware|download|software)\b/.test(q)) return ['file-version', 'no-download'];
      if (/\b(warranty|repair)\b/.test(q)) return /\b(expired|outside|out)\b/.test(q) ? ['out-of-warranty', 'warranty-period'] : ['warranty-period', 'out-of-warranty'];
      if (/\b(return|returns|rma)\b/.test(q)) return /\b(address|send|ship)\b/.test(q) ? ['return-address', 'return-deadline'] : /\b(open|opened|used)\b/.test(q) ? ['opened-return', 'return-address'] : ['sealed-return', 'opened-return', 'return-address'];
      if (/\b(no reply|not replied|no response|follow up|followup)\b/.test(q)) return ['follow-up', 'first-response'];
      if (/\b(no order number|without order)\b/.test(q)) return ['no-order-number'];
      if (/\b(amazon|aliexpress|seller)\b/.test(q)) return ['marketplace'];
      if (/\b(customs|duties|tax)\b/.test(q)) return ['duties'];
      return [];
    }
    function search(records, value, group) {
      var qn = normalize(value), pool = (records || []).filter(function (r) { return !group || r.group === group; });
      if (!qn) return pool.slice();
      var preferred = intent(qn).filter(function (id) { return pool.some(function (r) { return r.id === id; }); });
      var tokens = Array.from(new Set(qn.split(' ').filter(function (t) { return t.length > 1 && !stop.has(t); })));
      return pool.map(function (r, index) {
        var p = preferred.indexOf(r.id);
        var title = normalize(r.question), body = normalize(r.answer + ' ' + r.group);
        var matched = tokens.filter(function (t) { return title.indexOf(t) > -1 || body.indexOf(t) > -1; });
        var score = p >= 0 ? 300 - p * 30 : 0;
        if (preferred.length && p < 0) return { r: r, score: 0, index: index };
        if (!preferred.length && tokens.length && matched.length >= Math.ceil(tokens.length * 0.55)) {
          score += matched.length * 5 + tokens.filter(function (t) { return title.indexOf(t) > -1; }).length * 9;
          if (title.indexOf(qn) > -1) score += 30;
        }
        return { r: r, score: score, index: index };
      }).filter(function (x) { return x.score > 0; }).sort(function (a, b) { return b.score - a.score || a.index - b.index; }).map(function (x) { return x.r; });
    }
    return { search: search };
  })();

  /* ---------- Shared dialog handling (prototype support-home.js) ---------- */
  var lock = { opener: null, overflow: '', locked: false };
  function openDialog(d, from) {
    lock.opener = from || null;
    if (!lock.locked) { lock.overflow = document.body.style.overflow; lock.locked = true; }
    document.body.style.overflow = 'hidden';
    d.showModal();
    var h = d.querySelector('h2'); if (h) h.focus({ preventScroll: true });
  }
  function restore() {
    if (!lock.locked) return;
    lock.locked = false;
    document.body.style.overflow = lock.overflow;
    if (lock.opener && lock.opener.isConnected) lock.opener.focus({ preventScroll: true });
    lock.opener = null;
  }
  function closeDialog(d) { if (d.open) d.close(); restore(); }
  function wireDialog(d) {
    d.addEventListener('keydown', function (e) {
      if (e.key !== 'Tab') return;
      var items = qa('a[href],button:not([disabled]),input,select,textarea,[tabindex="0"]', d).filter(function (el) { return el.getClientRects().length && !el.closest('[hidden]'); });
      if (!items.length) { e.preventDefault(); return; }
      var first = items[0], last = items[items.length - 1];
      if (e.shiftKey && (document.activeElement === first || items.indexOf(document.activeElement) < 0)) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    });
    d.addEventListener('cancel', function (e) { e.preventDefault(); closeDialog(d); });
    d.addEventListener('close', restore);
    d.addEventListener('click', function (e) {
      if (e.target !== d) return;
      var r = d.getBoundingClientRect();
      if (e.clientX < r.left || e.clientX > r.right || e.clientY < r.top || e.clientY > r.bottom) closeDialog(d);
    });
    qa('[data-sp-close]', d).forEach(function (b) { b.addEventListener('click', function () { closeDialog(d); }); });
  }
  function modifier(e) { return e.metaKey || e.ctrlKey || e.shiftKey || e.altKey; }

  /* ---------- Home: delivery help + order rules ---------- */
  function home(c) {
    var delivery = q('[data-delivery-dialog]'), rules = q('[data-order-rules-dialog]');
    var stages = c.stages || {}, fallback = c.defaultStage || Object.keys(stages)[0];
    if (delivery && typeof delivery.showModal === 'function') {
      wireDialog(delivery);
      var paint = function (id) {
        var cur = stages[id] ? id : fallback, item = stages[cur];
        if (!item) return;
        qa('[data-delivery-stage]', delivery).forEach(function (b) { b.setAttribute('aria-pressed', String(b.dataset.deliveryStage === cur)); });
        q('[data-delivery-title]', delivery).textContent = item.title;
        q('[data-delivery-body]', delivery).textContent = item.body;
        var steps = q('[data-delivery-steps]', delivery);
        steps.replaceChildren();
        (item.steps || []).forEach(function (s) { var li = document.createElement('li'); li.textContent = s; steps.append(li); });
        steps.hidden = !(item.steps || []).length;
        var a = q('[data-delivery-cta]', delivery);
        a.href = caseURL(c.contact, cur, item.topic);
        q('[data-delivery-cta-label]', a).textContent = item.cta;
      };
      qa('[data-delivery-open]').forEach(function (a) {
        a.addEventListener('click', function (e) {
          if (modifier(e)) return;
          e.preventDefault(); paint(a.dataset.deliveryOpen); openDialog(delivery, a);
        });
      });
      qa('[data-delivery-stage]', delivery).forEach(function (b) { b.addEventListener('click', function () { paint(b.dataset.deliveryStage); }); });
      var help = params.get('help');
      if (help && stages[help]) { paint(help); openDialog(delivery, q('[data-delivery-open]')); }
    }
    if (rules && typeof rules.showModal === 'function') {
      wireDialog(rules);
      qa('[data-order-rules-open]').forEach(function (a) {
        a.addEventListener('click', function (e) { if (modifier(e)) return; e.preventDefault(); openDialog(rules, a); });
      });
    }
  }

  /* ---------- After-sales: next-step helper ---------- */
  function after(c) {
    var f = q('[data-route-form]');
    if (!f) return;
    var o = c.outcomes || {}, condition = q('[data-condition-field]', f), result = q('[data-route-result]', f);
    function pick(channel, issue, cond) {
      if (channel === 'elsewhere') return o.elsewhere;
      if (channel === 'unsure') return o.channel_unsure;
      if (issue !== 'return') return o[issue];
      return o[cond === 'unsure' ? 'condition_unsure' : cond];
    }
    function route() {
      var issue = f.elements.issue.value;
      condition.hidden = issue !== 'return';
      var r = pick(f.elements.channel.value, issue, f.elements.condition.value) || {};
      q('h4', result).textContent = r.title || '';
      q('p', result).textContent = r.body || '';
      q('a', result).href = caseURL(c.contact, null, r.topic || 'other');
    }
    f.addEventListener('change', route);
    f.addEventListener('submit', function (e) { e.preventDefault(); route(); result.focus(); });
    route();
  }

  /* ---------- FAQ page ---------- */
  function faq(c) {
    var root = q('[data-sp-faq]');
    if (!root) return;
    var t = c.t || {}, items = c.items || [], group = '';
    var input = q('[data-faq-query]', root), count = q('[data-faq-count]', root), empty = q('[data-faq-empty]', root);
    var details = qa('[data-faq-id]', root), parent = details[0] && details[0].parentElement;
    function pressed(v) { qa('[data-faq-group]', root).forEach(function (b) { b.setAttribute('aria-pressed', String(b.dataset.faqGroup === v)); }); }
    function filter() {
      var ranked = Search.search(items, input.value, group), ids = new Set(ranked.map(function (f) { return f.id; }));
      if (parent) ranked.forEach(function (f) { var d = details.find(function (x) { return x.dataset.faqId === f.id; }); if (d) parent.append(d); });
      details.forEach(function (d) { d.hidden = !ids.has(d.dataset.faqId); });
      var n = ids.size;
      count.textContent = fill(group ? t.count_group : (n === 1 ? t.count_one : t.count_other), { n: n, group: group });
      empty.hidden = n > 0;
    }
    input.addEventListener('input', filter);
    q('[data-faq-form]', root).addEventListener('submit', function (e) { e.preventDefault(); filter(); count.focus({ preventScroll: true }); });
    qa('[data-faq-group]', root).forEach(function (b) { b.addEventListener('click', function () { group = b.dataset.faqGroup; pressed(group); filter(); }); });
    var reset = q('[data-faq-reset]', root);
    if (reset) reset.addEventListener('click', function () { input.value = ''; group = ''; pressed(''); filter(); input.focus(); });
    input.value = params.get('q') || '';
    filter();
    function openHash() {
      var id = '';
      try { id = decodeURIComponent(location.hash.slice(1)); } catch (e) { return; }
      var target = details.find(function (x) { return x.id === id; });
      if (target) { input.value = ''; group = ''; pressed(''); filter(); target.open = true; }
    }
    openHash();
    window.addEventListener('hashchange', openHash);
  }

  /* ---------- Track page ---------- */
  function track(c) {
    var t = c.t || {}, input = q('[data-tracking-input]');
    if (!input) return;
    var feedback = q('[data-track-status]'), err = q('[data-tracking-error]');
    function valid() {
      var value = input.value.trim().replace(/\s+/g, ' ');
      err.hidden = true; input.removeAttribute('aria-invalid');
      if (/^[A-Za-z0-9][A-Za-z0-9 -]{4,79}$/.test(value)) return value;
      input.setAttribute('aria-invalid', 'true'); err.hidden = false; input.focus();
      return '';
    }

    var copyBtn = q('[data-copy-tracking]');
    if (copyBtn) copyBtn.addEventListener('click', function () {
      var value = valid();
      if (!value) return;
      copyText(value).then(function () { feedback.textContent = t.copied || ''; }, function () { feedback.textContent = t.copy_failed || ''; input.select(); });
    });
    if (!c.embed) return;

    var form = q('[data-track-form]'), box = q('[data-tracker]'), submit = q('[data-track-submit]');
    var fallback = q('[data-tracker-fallback]');
    var loader = null;
    function load17() {
      if (window.YQV5) return Promise.resolve();
      if (loader) return loader;
      loader = new Promise(function (resolve, reject) {
        var s = document.createElement('script');
        s.src = 'https://www.17track.net/externalcall.js';
        s.async = true;
        s.onload = function () { window.YQV5 ? resolve() : reject(); };
        s.onerror = reject;
        document.head.appendChild(s);
        setTimeout(reject, 12000);
      });
      loader.catch(function () { loader = null; });
      return loader;
    }
    function fallbackURL(num) { return safeURL(fill(c.fallback || 'https://t.17track.net/en#nums={num}', { num: encodeURIComponent(num) })); }
    function run(num, focusResults) {
      if (fallback) fallback.href = fallbackURL(num);
      feedback.textContent = t.loading || '';
      if (submit) submit.setAttribute('aria-busy', 'true');
      load17().then(function () {
        box.hidden = false;
        window.YQV5.trackSingle({ YQ_ContainerId: c.frame, YQ_Height: c.height || 560, YQ_Fc: '0', YQ_Lang: c.lang || 'en', YQ_Num: num });
        feedback.textContent = fill(t.loaded, { num: num });
        if (focusResults) box.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'nearest' });
      }, function () {
        box.hidden = false;
        feedback.textContent = t.load_error || '';
      }).then(function () { if (submit) submit.removeAttribute('aria-busy'); });
    }
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var num = valid();
      if (num) run(num, true);
    });
    var start = params.get('nums') || params.get('num') || params.get('tracking') || '';
    if (start) { input.value = start.split(',')[0]; var n = valid(); if (n) run(n, false); }
  }

  /* ---------- Contact page (real Shopify contact form) ---------- */
  function contact(c) {
    var f = q('[data-sp-contact] form');
    if (!f) return;
    var t = c.t || {}, cases = c.cases || {};
    var topic = q('#sp-topic', f), message = q('#sp-message', f), email = q('#sp-email', f), product = q('#sp-product', f);
    var summary = q('[data-error-summary]', f);
    f.noValidate = true;
    function topicOption(id) { return Array.from(topic.options).find(function (o) { return o.dataset.topic === id; }); }
    function currentTopic() { var o = topic.options[topic.selectedIndex]; return o ? o.dataset.topic : ''; }
    function helpUpdate() {
      var o = topic.options[topic.selectedIndex];
      q('[data-topic-title]', f).textContent = o ? o.dataset.helpTitle || '' : '';
      q('[data-topic-help]', f).textContent = o ? o.dataset.help || '' : '';
    }
    var tp = params.get('topic'); if (tp && topicOption(tp)) topic.value = topicOption(tp).value;
    var caseID = params.get('case'), selected = Object.prototype.hasOwnProperty.call(cases, caseID) ? cases[caseID] : null, aside = null;
    if (selected && !f.querySelector('[data-sp-posted]')) {
      if (topicOption(selected.topic)) topic.value = topicOption(selected.topic).value;
      if (!message.value) message.value = selected.message || '';
      aside = document.createElement('aside');
      aside.className = 'sh-case-summary';
      var h = document.createElement('h3'), p = document.createElement('p'), a = document.createElement('a');
      h.textContent = selected.label; p.textContent = selected.body; a.href = c.home || '/pages/support'; a.textContent = t.back || '';
      aside.append(h, p); if (a.textContent) aside.append(a);
      f.prepend(aside);
    }
    var formName = q('[data-sp-form-name]', f);
    function nameUpdate() {
      if (!formName) return;
      var o = topic.options[topic.selectedIndex];
      formName.value = formName.dataset.spFormName + (o && o.value ? ' – ' + o.value : '');
    }
    topic.addEventListener('change', nameUpdate);
    nameUpdate();
    topic.addEventListener('change', function () {
      if (selected && currentTopic() !== selected.topic) {
        if (message.value === selected.message) message.value = '';
        if (aside) aside.remove();
        selected = null;
      }
      helpUpdate();
    });
    helpUpdate();
    nameUpdate();
    var handle = params.get('product');
    if (handle && product && !product.value && /^[a-z0-9-]{1,120}$/.test(handle)) {
      fetch('/products/' + handle + '.js').then(function (r) { return r.ok ? r.json() : null; }).then(function (p) { if (p && !product.value) product.value = p.title; }).catch(function () {});
    }
    function resetErrors() {
      summary.hidden = true;
      qa('[data-error-for]', f).forEach(function (e) { e.textContent = ''; e.hidden = true; });
      qa('[aria-invalid]', f).forEach(function (e) { e.removeAttribute('aria-invalid'); });
    }
    function error(el, msg) {
      el.setAttribute('aria-invalid', 'true');
      var tx = q('[data-error-for="' + el.id + '"]', f); tx.textContent = msg; tx.hidden = false;
      return '<li><a href="#' + el.id + '">' + esc(msg) + '</a></li>';
    }
    f.addEventListener('submit', function (e) {
      resetErrors();
      var errs = [];
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email.value.trim())) errs.push(error(email, t.email_invalid));
      var len = message.value.trim().length;
      if (len < 10) errs.push(error(message, t.message_short));
      else if (message.value.length > 1800) errs.push(error(message, t.message_long));
      if (!errs.length) return;
      e.preventDefault(); e.stopImmediatePropagation();
      q('ul', summary).innerHTML = errs.join('');
      summary.hidden = false; summary.focus();
    }, { capture: true });
    var posted = f.querySelector('[data-sp-posted]');
    if (posted) { posted.scrollIntoView({ block: 'center' }); posted.focus({ preventScroll: true }); }
  }

  /* ---------- Downloads page ---------- */
  function downloads(c) {
    var root = q('[data-sp-downloads]');
    if (!root) return;
    var t = c.t || {}, resources = c.resources || [];
    var query = q('[data-resource-query]', root), brand = q('[data-resource-brand]', root), type = q('[data-resource-type]', root);
    var records = qa('[data-resource-id]', root), count = q('[data-resource-count]', root), empty = q('[data-resource-empty]', root), box = q('[data-model-results]', root);
    var timer = 0, seq = 0;
    function lookup(value, b) {
      var mine = ++seq;
      fetch('/search/suggest.json?q=' + encodeURIComponent(value) + '&resources[type]=product&resources[limit]=10')
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (json) {
          if (mine !== seq) return;
          var found = ((((json || {}).resources || {}).results || {}).products || [])
            .filter(function (p) { return !b || text(p.vendor) === text(b); }).slice(0, 6);
          box.hidden = false;
          box.innerHTML = '<h3>' + esc(t.products_heading) + '</h3>' + (found.length ? found.map(function (p) {
            var exact = resources.filter(function (r) { return r.models.indexOf(p.handle) > -1; });
            var library = resources.filter(function (r) { return !r.models.length && text(r.brand) === text(p.vendor); });
            var linked = exact.length ? exact : library;
            var note = linked.length ? (exact.length ? t.model_exact : t.model_brand) : t.model_none;
            var help = caseURL(c.contact, null, 'download') + '&product=' + encodeURIComponent(p.handle);
            return '<article class="sp-model-result"><div><h3>' + esc(p.title) + '</h3><p>' + esc(note) + '</p></div><nav aria-label="' + esc(fill(t.resources_for, { name: p.title })) + '">' +
              linked.map(function (r) { return '<a href="' + esc(safeURL(r.url)) + '" target="_blank" rel="noopener noreferrer">' + esc(exact.length ? t.open_model : t.open_library) + ' \u2197</a>'; }).join('') +
              '<a href="' + esc(help) + '">' + esc(t.request_help) + '</a><a href="' + esc(p.url) + '">' + esc(t.product_info) + '</a></nav></article>';
          }).join('') : '<div class="sp-empty"><p>' + esc(t.no_model) + '</p><a class="sp-link" href="' + esc(caseURL(c.contact, null, 'download')) + '">' + esc(t.request_resource) + '</a></div>');
        }).catch(function () { if (mine === seq) box.hidden = true; });
    }
    function run() {
      var value = text(query.value), b = brand.value, ty = type.value, parts = value.split(' ').filter(Boolean), num = 0;
      records.forEach(function (el) {
        var r = resources.find(function (x) { return x.id === el.dataset.resourceId; });
        var good = r && (!b || text(r.brand) === text(b)) && (!ty || r.type === ty) &&
          parts.every(function (p) { return text(r.title + ' ' + r.brand + ' ' + r.keywords + ' ' + r.detail).indexOf(p) > -1; });
        el.hidden = !good; if (good) num++;
      });
      count.textContent = fill(num === 1 ? t.count_one : t.count_other, { n: num });
      empty.hidden = num > 0;
      clearTimeout(timer);
      if (!value) { seq++; box.hidden = true; return; }
      timer = setTimeout(function () { lookup(query.value.trim(), b); }, 220);
    }
    query.value = params.get('q') || '';
    var pb = params.get('brand');
    if (pb && Array.from(brand.options).some(function (x) { return x.value === pb; })) brand.value = pb;
    query.addEventListener('input', run);
    brand.addEventListener('change', run);
    type.addEventListener('change', run);
    q('[data-resource-form]', root).addEventListener('submit', function (e) { e.preventDefault(); run(); count.focus({ preventScroll: true }); });
    var reset = q('[data-resource-reset]', root);
    if (reset) reset.addEventListener('click', function () { query.value = ''; brand.value = ''; type.value = ''; run(); query.focus(); });
    run();
  }

  function init() {
    var mods = { home: home, after: after, faq: faq, track: track, contact: contact, downloads: downloads };
    Object.keys(mods).forEach(function (k) {
      if (!cfg[k]) return;
      try { mods[k](cfg[k]); } catch (e) { console.error('Support ' + k + ' unavailable', e); }
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();
